module.exports = __webpack_public_path__ + "img/map_5.3cb3a7a9.png";